export enum OrganizationAttributeName {
    RCM_AI_PLATFORM_ENABLED = 'RCM_AI_PLATFORM_ENABLED'
}

export interface EnterpriseApplicationDto {
    organizationId: number;
    siteUrl: string;
    globalIdentifier: string;
    enterpriseLoginEnabled?: boolean;
    attributes: Partial<Record<OrganizationAttributeName, string>>;
}
